export default __webpack_public_path__ + "assets/media/search.78962ed4.png";